import { useLocation } from '@rocketlane/rocket-router';
import { useMemo } from 'react';

export const useQueryParams = () => {
  const location = useLocation();

  return useMemo(() => new URLSearchParams(location.search), [location.search]);
};
